import { createEvent } from 'effector';
import {
    type InternalApiHttpAuthLoginResponse,
    type InternalApiHttpAuthGetMeResponse,
} from '~/generated/authBackend/model';
import { type AuthSession } from './store';

export const appStarted = createEvent();

export const updateAuthSession = createEvent<Partial<AuthSession>>();
export const loginSucceeded = createEvent<InternalApiHttpAuthLoginResponse>();
export const logoutSucceeded = createEvent<void>();
export const getMeSucceeded = createEvent<InternalApiHttpAuthGetMeResponse>();
export const refreshTokenSucceeded = createEvent<{ accessToken: string }>();
